import { render, staticRenderFns } from "./SurveyImprovement.vue?vue&type=template&id=3ed8d05a&scoped=true&"
import script from "./SurveyImprovement.vue?vue&type=script&lang=js&"
export * from "./SurveyImprovement.vue?vue&type=script&lang=js&"
import style0 from "./SurveyImprovement.vue?vue&type=style&index=0&id=3ed8d05a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8d05a",
  null
  
)

export default component.exports